
import { Component, Vue } from "nuxt-property-decorator";
import ContentPageLayout from "~/components/molecules/display/ContentPageLayout.vue";
import { generateMetaTags } from "~/operations/meta-helper-functions";
import type { FaqItem, JumpNavItem } from "~/types/ContentPage";

@Component({
  scrollToTop: true,
  components: {
    ContentPageLayout,
  },
})
export default class PelletlagerRatgeber extends Vue {
  faqItems: FaqItem[] = [
    {
      question: "Wie groß muss ein Pelletlager für ein Einfamilienhaus sein?",
      answer:
        "Bei einem Einfamilienhaus mit 15 kW Heizlast sollte das Pelletlager etwa 14 m³ groß sein. Berechnung: 15 kW × 0,9 m³/kW = 13,5 m³.",
    },
    {
      question: "Wann sollte man ein Pelletlager reinigen?",
      answer:
        "Ein Pelletlager sollte alle 2 Jahre oder nach 2 bis 3 Befüllungen komplett entleert und gründlich gereinigt werden. Dies verhindert die Ansammlung von Feinstaub.",
    },
    {
      question: "Was kostet ein Pelletlager?",
      answer:
        "Ein Pelletbunker kostet zwischen 1.500 und 3.500 Euro, ein Pelletsilo zwischen 2.000 und 4.000 Euro. Die Kosten variieren je nach Größe und Ausstattung.",
    },
    {
      question: "Wie viele Pellets darf man lagern?",
      answer:
        "Nach der deutschen Muster-Feuerungsverordnung dürfen Pellets unter 6,5 Tonnen ohne speziellen Brennstofflagerraum gelagert werden. Über dieser Grenze gelten Brandschutzvorschriften.",
    },
    {
      question: "Welches Pelletlager ist am günstigsten?",
      answer:
        "Gewebe- und Sacksilos sind oft die preiswerteste Option für kleinere Mengen. Ein umfunktionierter Raum kann ebenfalls als günstiges Pelletlager dienen.",
    },
  ];

  head() {
    return {
      ...generateMetaTags(this.$route.path, "pelletlager"),
      link: [{ rel: "canonical", href: this.$route.path }],
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: this.faqItems.map((faq) => ({
              "@type": "Question",
              name: faq.question,
              acceptedAnswer: {
                "@type": "Answer",
                text: faq.answer,
              },
            })),
          },
        },
      ],
    };
  }

  get jumpNavItems(): JumpNavItem[] {
    return [
      {
        name: "Größe richtig berechnen",
        title: "Springen Sie zum Bereich: Größe berechnen",
        href: { hash: "#anker-groesse" },
      },
      {
        name: "Der optimale Standort für Ihr Pelletlager",
        title: "Springen Sie zum Bereich: Optimaler Standort",
        href: { hash: "#anker-standort" },
      },
      {
        name: "Pelletlager Arten: Vor- und Nachteile",
        title: "Springen Sie zum Bereich: Lager-Arten",
        href: { hash: "#anker-arten" },
      },
      {
        name: "Sicherheitsstandards für Pelletlager",
        title: "Springen Sie zum Bereich: Sicherheitsstandards",
        href: { hash: "#anker-sicherheit" },
      },
      {
        name: "Tipps für optimale Pelletlagerung",
        title: "Springen Sie zum Bereich: Lager-Tipps",
        href: { hash: "#anker-tipps" },
      },
      {
        name: "FAQ",
        title: "Springen Sie zum Bereich: Häufige Fragen",
        href: { hash: "#anker-faq" },
      },
      {
        name: "Das perfekte Pelletlager planen",
        title: "Springen Sie zum Bereich: Pelletlager planen",
        href: { hash: "#anker-planen" },
      },
    ];
  }
}
